let noop = function(){}

class DebouncePromiseQueue  {
    constructor() {
        this.queue = [];
        this.promise = Promise.resolve();
    }
    push (resolve, reject = noop, delay=100) {
        this.queue.push([resolve, reject]);
        return new Promise((/* res *//* rej */)=>{
            setTimeout(() => {
                return this.exec();
            }, delay);
        })
    }
    exec () {
        if (this.execIng) {
            return;
        }
        let last = this.queue.pop();
        if (!last) {
            return;
        }
        this.execIng = true;
        for (let i = 0, j = this.queue.length; i < j; i++) {
            this.queue[i][1]();
        }
        this.queue = [];

        return Promise.resolve(last[0]()).catch(() => {
            try{
                return Promise.resolve(last[1]()).catch(noop);
            } catch(ex){}
        }).finally(() => {
            this.execIng = false;
            setTimeout(() => {this.exec();}, 30);
        });
    }
    end () {
        this.queue = [];
    }
}


export default DebouncePromiseQueue
